import { render, staticRenderFns } from "./FirmDetail.vue?vue&type=template&id=d56e3246&scoped=true&"
import script from "./FirmDetail.vue?vue&type=script&lang=js&"
export * from "./FirmDetail.vue?vue&type=script&lang=js&"
import style0 from "./FirmDetail.vue?vue&type=style&index=0&id=d56e3246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56e3246",
  null
  
)

export default component.exports